import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PromoEntity } from './promo.entity';

// Polymorphic targeting for promotions. Union semantics — any matching
// row qualifies the customer for the promo. Empty target set ⇒ tenant-wide.
@Index('idx_promo_target_promo', ['fkPromoId'])
@Index('idx_promo_target_resolve', ['targetType', 'targetRefId'])
@Index('idx_promo_target_value', ['targetType', 'targetRefValue'])
@Entity('promo_target')
export class PromoTargetEntity extends BaseEntity {
	@Column('int', { name: 'fk_promo__id', unsigned: true })
	public fkPromoId!: number;

	// TENANT (no rows is the default tenant-wide signal — explicit TENANT
	// rows are accepted but not required). COMPANY/CLIENT/CLIENT_GROUP use
	// targetRefId. CLIENT_BUSINESS_TYPE uses targetRefValue.
	@Column('varchar', { name: 'targetType', length: 32 })
	public targetType!:
		| 'TENANT'
		| 'COMPANY'
		| 'CLIENT'
		| 'CLIENT_GROUP'
		| 'CLIENT_BUSINESS_TYPE';

	@Column('int', { name: 'targetRefId', nullable: true, unsigned: true })
	public targetRefId!: number | null;

	@Column('varchar', { name: 'targetRefValue', nullable: true, length: 255 })
	public targetRefValue!: string | null;

	@ManyToOne(() => PromoEntity, (promo) => promo.promoTargets, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_promo__id', referencedColumnName: 'id' }])
	public fkPromo!: PromoEntity;
}
